import { alarmDataToModel } from '@akin-home/alarms/frontend';
import { alertDataToModel } from '@akin-home/alerts/frontend';
import {
  Alarm,
  Alert,
  CalendarItemType,
  Event,
  Meal,
} from '@akin-home/amplify';
import { eventDataToModel } from '@akin-home/events/frontend';
import { mealGraphqlToModel } from '@akin-home/meals/frontend';
import { CalendarItemUnion } from '../types';

type Item = Event | Alert | Alarm | Meal;

export const formatCalendarItemToModel = (item: Item): CalendarItemUnion => {
  switch (item.type) {
    case CalendarItemType.Event:
      return eventDataToModel(item as Event);
    case CalendarItemType.Alert:
      return alertDataToModel(item as Alert);
    case CalendarItemType.Alarm:
      return alarmDataToModel(item as Alarm);
    case CalendarItemType.Meal:
      return mealGraphqlToModel(item as Meal);
    default:
      return eventDataToModel(item as Event);
  }
};
